import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/dlf-logo.PNG"
          width="150px"
          height="70px"
          loading="lazy"
          alt="logo"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h2 className="d-block section-heading-sub text-capitalize">
            About Developer
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={() => handleShowModal("AboutDev ChatWithUs")}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        DLF has spent over seven decades crafting the landmarks that define
        India's urban story. From pioneering colonies in Delhi to transforming
        Gurugram into a global business hub, DLF has consistently shaped the
        skyline with vision, integrity, and excellence. Today, as India’s
        largest publicly listed real estate developer, DLF operates across 15
        states and 24 cities — building not just structures, but entire
        ecosystems. With a commitment to design innovation, customer-first
        ethics, and uncompromising quality, DLF continues to set benchmarks in
        residential, commercial, and retail spaces. At the heart of it all lies
        a single belief: to create timeless spaces where people thrive,
        communities grow, and legacies endure.
      </p>

      <div className="rera-numbers">
        <div className="rera-item">
          <img src="images/PR1181012500079.jfif" alt="rera qr" />
          <strong>PR1181012500079</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <p></p>
      <button
        className="btn btn-info micro-form-btn enqModal effetGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("AboutDev ChatWithUs")}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
